const LoadingSpinner: FC = () => {
    return (
        <div className="loading-spinner">
            <div className="lds-default">
                {Array.from({ length: 12 }).map((_, index) => (
                    <div key={index}></div>
                ))}
            </div>
        </div>
    );
};

export default LoadingSpinner;
